import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { TreeEditor } from '../../../../components/tree/TreeEditor';
import { ProjectDocFolder } from '../../models/ProjectDocFolder';
import { ProjectDocFolderTreeNode } from '../../models/ProjectDocFolderTreeNode';
import { DocTemplateFolderTypeVals } from '../../../../helpers/constants/modelValues/DocTemplateFolderTypeVals';
import { buildTreeFromProjectDocFolders } from '../../../../helpers/tree/ProjectDocFolder';
import { services } from '../../../../services';
import { useBackgroundPromiseWrapper } from '../../../../helpers/hooks/useBackgroundPromiseWrapper';

interface PaperSigningTabProps {
    projectDocId: number;
    selectedSlotId?: number;
    onSelectSlot: (node: ProjectDocFolderTreeNode) => void;
}

export const PaperSigningTab: React.FC<PaperSigningTabProps> = ({ projectDocId, selectedSlotId, onSelectSlot }) => {
    const [promiseWrapper] = useBackgroundPromiseWrapper();
    const [folders, setFolders] = React.useState<ProjectDocFolder[]>([]);
    const dictionaries = useSelector((appState: ApplicationState) => appState.dictionariesContext.dictionariesContext);

    React.useEffect(() => {
        if (projectDocId === 0) return;
        promiseWrapper(
            () =>
                services.projectDocFolderService.fetch({
                    ProjectDocIds: [projectDocId],
                    TypeIds: [DocTemplateFolderTypeVals.PaperSigningRoot, DocTemplateFolderTypeVals.Tom],
                    IsDeleted: false,
                    Take: 9999
                }),
            (res: ProjectDocFolder[]) => setFolders(res)
        );
    }, [projectDocId]);

    const treeNodes = React.useMemo(
        () => buildTreeFromProjectDocFolders(folders, dictionaries.ProjectDocFolderStatuses, null),
        [folders, dictionaries]
    );

    if (folders.length === 0) {
        return <div className="p-3 text-muted">Нет разделов для подписания</div>;
    }

    return (
        <TreeEditor
            treeNodes={treeNodes}
            leafMenuItems={[]}
            nodeMenuItems={[]}
            workTypeMenuItems={[]}
            actMenuItems={[]}
            actDocumentMenuItems={[]}
            actDocumentSectionMenuItems={[]}
            actSectionMenuItems={[]}
            onMenu={() => {}}
            onPositionsChanged={() => {}}
            canEditNode={() => false}
            enableScroll={true}
            selectionMode="single"
            selectionKeys={selectedSlotId as any}
            onSelect={(e) => {
                const node = e.node as ProjectDocFolderTreeNode;
                if (node.FolderTypeId === DocTemplateFolderTypeVals.Tom) {
                    onSelectSlot(node);
                }
            }}
        />
    );
};
